"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RATING_SCALE = exports.PERFORMANCE_COMPETENCIES = void 0;
exports.PERFORMANCE_COMPETENCIES = [
    {
        key: 'selfManagement',
        title: 'Self Management — Taking Ownership',
        description: 'Takes accountability for actions, and follows through reliably on commitments with a sense of urgency. Acts in the best interest of the team and company and takes initiative to bring positive results.',
        ratingField: 'ratingSelfManagement',
        essayField: 'essaySelfManagement'
    },
    {
        key: 'communication',
        title: 'Communication — Communicating Effectively',
        description: 'Able to deliver messages in a way that allows clear understanding and action from others. Able to actively listen, understand, and take action on what others say. When faced with disagreements, communicates in a constructive manner to bring positive outcomes.',
        ratingField: 'ratingCommunication',
        essayField: 'essayCommunication'
    },
    {
        key: 'projectManagement',
        title: 'Project Management — Managing Expectations',
        description: 'Sets and manages stakeholder expectations throughout projects — through prioritization, proactive planning, collaborative problem solving, and active communication, in order to ensure timely delivery of quality outcomes.',
        ratingField: 'ratingProjectManagement',
        essayField: 'essayProjectManagement'
    },
    {
        key: 'functionalCompetence',
        title: 'Functional Competence',
        description: 'Has the functional skills (technical or business) required to do what is expected. Delivers consistent, error-free output. Actively seeks to fill functional skills gaps via self-learning or seeking mentors inside or outside this organization.',
        ratingField: 'ratingFunctionalCompetence',
        essayField: 'essayFunctionalCompetence'
    }
];
exports.RATING_SCALE = [
    { value: 1, label: 'Below expectation' },
    { value: 2, label: 'Meet expectation' },
    { value: 3, label: 'Exceed expectation' },
    { value: 4, label: 'Setting new standard' }
];
//# sourceMappingURL=performance.js.map